/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jack-henry/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import { GuidKeyCollectionDto } from "../";
import { HttpClient, RequestParams } from "./http-client";

@Injectable()
export class SecCodesClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags SecCodes
   * @name SecCodesGet
   * @summary Gets All The SEC Codes
   * @request GET:/secCodes
   */
  secCodesGet = (params: RequestParams = {}) =>
    this.http.request<GuidKeyCollectionDto, any>({
      path: `/secCodes`,
      method: "GET",
      format: "json",
      ...params,
    });
}
